import React from 'react'
import { Container } from 'react-bootstrap'
import { buildDate, buildVersion } from '@config/environment.config'
import { useTheme } from '@config/theme.config'

const FooterComponent = () => {
  const { theme } = useTheme()
  const buildDateString = buildDate?.toISOString()
  return (
    <footer
      className={`footer bg-${theme} text-${theme === 'dark' ? 'light' : 'dark'}`}
    >
      <Container className={'d-flex justify-content-between '}>
        <p></p>
        <p
          className={'text-secondary fw-lighter'}
        >{`${buildDateString}-${buildVersion}`}</p>
      </Container>
    </footer>
  )
}

export default FooterComponent
